import React, { Component } from 'react';
import SequenceList from '../workouts/SequenceList';
import { BLOCK_ADDED_MESSAGE } from '../../static-content';
import AlertMessage from '../AlertMessage';
import { COLORS } from '../../styles/colors';
/**
 * Info
 */
export class Info extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    dataLoaded: false
  }
  componentDidMount() {
    this.props.fetchBlock(this.props.editId).then(() => {
      this.setState({
        ...this.state,
        dataLoaded: true
      })
    });
  }

  render() {
    const { dataLoaded } = this.state;
    const { title = true } = this.props;
    if (dataLoaded) {
      const { blockInfo: block } = this.props;
      const { sequences, circuits, plans } = block.info;
      const queryParams = this.props.location ? new URLSearchParams(this.props.location.search) : null;
      const showMessage = queryParams ? queryParams.get('new') : false;
      return (
        <div>
          {
            showMessage ? (
              <AlertMessage
                subject="Block added!"
                body={BLOCK_ADDED_MESSAGE}
                icon={['far', 'check-square']}
              />
            ) : null
          }
          {title &&
            <div style={{
              backgroundColor: COLORS.greyFour,
              padding: 10,
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}>
                <div style={{
                  fontWeight: 'bold',
                  textAlign: 'center'
                }}>
                  {block.name}
                </div>
                <div style={{
                  color: COLORS.orange
                }}>
                  BLOCK
              </div>
              </div>
            </div>
          }
          <div style={{
            width: '100%',
            paddingBottom: 15
          }}>
            <SequenceList
              openVideoOverlay={(url) => this.openVideoOverlay(url)}
              changeParentImage={this.props.changeParentImage}
              sequences={Object.values(sequences)}
              circuits={circuits}
              plans={plans}
              workout={block}
            />
          </div>

        </div>
      );
    } else {
      return null;
    }

  }
}

export default Info;



// WEBPACK FOOTER //
// ./src/components/blocks/Info.js